/**
 * uuid
 */
export const getUuid = () => {
  let unique = 0;
  const time = Date.now();
  // eslint-disable-next-line no-undef
  unique++;
  return unique + String(time);
};

export const generateUuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
